import Image from "next/image";
import styles from "./Header.module.scss";

export const Header = function () {
  return (
    <div className={styles.headerImage}>
      <Image
        src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/f98aefaa-mitsloanlogo-executiveeducation-horizontal-master-web_0dm01s0dm01s00000001o.jpg"
        alt="university logo"
        width={306}
        height={40}
      />
    </div>
  );
};
